import { render, staticRenderFns } from "./registerDetail.vue?vue&type=template&id=673232f6&scoped=true"
import script from "./registerDetail.vue?vue&type=script&lang=js"
export * from "./registerDetail.vue?vue&type=script&lang=js"
import style0 from "./registerDetail.vue?vue&type=style&index=0&id=673232f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673232f6",
  null
  
)

export default component.exports